import { render } from "./AdminTrackPayment.vue?vue&type=template&id=3888e35c"
import script from "./AdminTrackPayment.vue?vue&type=script&lang=js"
export * from "./AdminTrackPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__